import React, { Component } from 'react'

import * as formatters from '../../../common/formatters'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

class DriversListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick(this.props.data.id)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete(this.props.data.id)
    }




    render = () => {

        const classNames = ['row-selectable']
        if (this.props.data.deleted_at) {
            classNames.push('is-deleted')
        }


        return (
            <tr onClick={this.handleClick} className={classNames.join(' ')}>
                <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                    <td className="w-60 table-buttons">
                        <PermissionsCheck has={[PERMS.UPDATE]}>
                            <button className="far fa-pencil text-gray m-r-xxs" />
                        </PermissionsCheck>
                        {!this.props.data.deleted_at && (
                            <PermissionsCheck has={[PERMS.DELETE]}>
                                <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                            </PermissionsCheck>
                        )}
                    </td>
                </PermissionsCheck>
                <td className="w-160">{this.props.data.last_name}</td>
                <td className="w-160">{this.props.data.first_name}</td>
                <td className="w-120 text-center">{this.props.driversType && this.props.driversType.name}</td>
                <td className="w-100">{this.props.data.code}</td>
                <td className="w-180">{this.props.data.card_number}</td>
                <td className="w-140">{this.props.dispatcher && this.props.dispatcher.getShortFullName()}</td>
                <td className="w-max wm-200">{this.props.data.phone}</td>
                <td className="w-100 text-center">{this.props.data.locale}</td>
                <td className="w-80 text-center">{formatters.boolFormatter(this.props.data.is_active)}</td>
            </tr>
        )
    }
}

export default DriversListRow
